import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedCampaignDraftTargetingStep =
  () => import(/* webpackChunkName: "campaign-draft-targeting-step.async" */ './campaign-draft-targeting-step')
    .then(({ CampaignDraftTargetingStepWithI18n }) => CampaignDraftTargetingStepWithI18n);

const DelayedCampaignDraftTargetingLazyRepository =
  () => import(/* webpackChunkName: "campaign-draft-targeting-step.async" */ './campaign-draft-targeting-lazy-repository')
    .then(({ CampaignDraftTargetingLazyRepository }) => CampaignDraftTargetingLazyRepository);

export const CampaignDraftTargetingStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_DRAFT_TARGETING,
  view: DelayedCampaignDraftTargetingStep,
  repository: DelayedCampaignDraftTargetingLazyRepository,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
  },
};
